import { ThemeVariants } from '@wvr/elements';

export const theme: ThemeVariants = {
  primary: {
    baseColor: '#500000'
  },
  primaryAccent: {
    baseColor: '#3c0000'
  },
  primaryNeutral: {
    baseColor: '#5a534d'
  },
  secondary: {
    baseColor: '#355963'
  },
  secondaryAccent: {
    baseColor: '#bcd4db'
  },
  secondaryNeutral: {
    baseColor: '#ededed'
  },
  success: {
    baseColor: '#00bc8c'
  },
  danger: {
    baseColor: '#E4002B'
  },
  warning: {
    baseColor: '#ffc222'
  },
  info: {
    baseColor: '#5bc0de'
  },
  dark: {
    baseColor: '#343a40'
  },
  light: {
    baseColor: '#f8f9fa'
  }
};
